/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Drop_Frame_LabelInputs */



/**
* | output |
* | --- |
* | "Dropframe" |
*
* @param {Subtitle_Import_Drop_Frame_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_drop_frame_label = /** @type {((inputs?: Subtitle_Import_Drop_Frame_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Drop_Frame_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dropframe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dropframe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Telaio a caduta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Dropframe")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dropframe")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("掉帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ドロップフレーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ड्रॉपफ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Dropframe")
	return /** @type {LocalizedString} */ ("Dropframe")
});